export const entranceBilling = {
	tabs: {
		pageTabs: {
			boxOffice: "Revenue",
			soldEntrances: "Tickets Sold",
			employeeReport: "Tickets by Employee",
		},
		boxOfficeBilling: {
			label: "Ticket Billing",
			value: "value",
			revenue: "revenue",
			percentage: "percentage",
			quantity: "quantity",
			filename: "ticket_billing",
		},
		soldEntrances: {
			label: "Total tickets sold",
			tabs: {
				total: "Total",
				clients: "Customers by Ticket",
			},
			columns: {
				name: "Name",
				count: "Units sold",
				averageValue: "Average price",
				totalValue: "Total",
			},
			total: "Total receipt",
			sheet: {
				title: "Tickets sold",
				fileName: "tickets_sold",
				name: "Nome",
				average: "Average value",
				count: "Quantity",
				totalValue: "Price",
			},
			filter: "Filter by hour",
			since: "since",
			until: "until",
			clientsReport: {
				title: "List of Customers by Ticket Sold",
				filterLabel: "Filter by Ticket Sold",
				filterPlaceholder: "Add filters by ticket",
				clients: "Customers",
				entranceValue: "Ticket Value",
				consumption: "Consumption",
				total: "Total",
				name: "Name",
				document: "Document",
				entrance: "Ticket",
				checkin: "Checkin",
				checkout: "Checkout",
				fileName: "customers-by-ticket-sold_{{date}}",
			},
		},
		entranceReport: {
			label: "Tickets sold by employees",
			filename: "tickets-sold-by-employees",
			columns: {
				name: "Name",
				count: "Quantity",
				unitValue: "Unit value",
				subtotal: "Subtotal",
				discountValue: "Discount",
				totalValue: "Total value",
				entrance: "Entrance",
			},
			sheet: {
				title: "Entrance",
				fileName: "entrance",
				name: "Name",
				count: "Quantity",
				unitValue: "Unit value",
				subtotal: "Subtotal",
				discountValue: "Discount",
				totalValue: "Total value",
			},
			total: "Total",
			totalCategory: "Total ({{category}})",
		},
	},
};
